// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSiteSearchPostRequest {
    static getAttributeTypeMap() {
        return PrescriberSiteSearchPostRequest.attributeTypeMap;
    }
}
PrescriberSiteSearchPostRequest.discriminator = undefined;
PrescriberSiteSearchPostRequest.additionalProperties = false;
PrescriberSiteSearchPostRequest.attributeTypeMap = [
    {
        "name": "applicationContext",
        "baseName": "applicationContext",
        "type": "number"
    },
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "number"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "number"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=prescriberSiteSearchPostRequest.js.map